import React from 'react';

export interface IconProps {
  size?: number;
  color?: string;
  className?: string;
}

// Resources
export const MetalIcon: React.FC<IconProps> = ({ size = 20, color = '#90caf9', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <polygon points="12 2 2 7 12 12 22 7 12 2" fill="rgba(144, 202, 249, 0.2)" />
    <polyline points="2 17 12 22 22 17" />
    <polyline points="2 12 12 17 22 12" />
  </svg>
);

export const He3Icon: React.FC<IconProps> = ({ size = 20, color = '#00e5ff', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="12" cy="12" r="9" fill="rgba(0, 229, 255, 0.15)" />
    <path d="M12 3a9 9 0 0 1 9 9" strokeDasharray="3 3" />
    <circle cx="12" cy="12" r="3" fill={color} />
  </svg>
);

export const CreditsIcon: React.FC<IconProps> = ({ size = 20, color = '#ffb300', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="12" cy="12" r="9" fill="rgba(255, 179, 0, 0.15)" />
    <path d="M12 7v10M9 9h6a2 2 0 0 1 0 4H9a2 2 0 0 0 0 4h6" />
  </svg>
);

export const PowerIcon: React.FC<IconProps> = ({ size = 20, color = '#ffd600', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" fill="rgba(255, 214, 0, 0.3)" />
  </svg>
);

// Hulls
export const CorvetteIcon: React.FC<IconProps> = ({ size = 36, color = '#00e5ff', className }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" stroke={color} strokeWidth="2" className={className}>
    <path d="M24 4 L34 26 L28 42 L24 38 L20 42 L14 26 Z" fill="rgba(0, 229, 255, 0.12)" />
    <path d="M24 10 L24 34" strokeDasharray="2 2" />
    <circle cx="24" cy="22" r="2" fill={color} />
  </svg>
);

export const FrigateIcon: React.FC<IconProps> = ({ size = 36, color = '#00e5ff', className }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" stroke={color} strokeWidth="2" className={className}>
    <path d="M24 4 L38 20 L42 36 L30 42 L24 36 L18 42 L6 36 L10 20 Z" fill="rgba(0, 229, 255, 0.14)" />
    <line x1="24" y1="8" x2="24" y2="34" />
    <line x1="16" y1="24" x2="32" y2="24" />
  </svg>
);

export const DestroyerIcon: React.FC<IconProps> = ({ size = 36, color = '#00e5ff', className }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" stroke={color} strokeWidth="2" className={className}>
    <path d="M24 2 L40 16 L44 32 L36 44 L28 40 L24 44 L20 40 L12 44 L4 32 L8 16 Z" fill="rgba(0, 229, 255, 0.16)" />
    <rect x="18" y="16" width="12" height="16" rx="2" stroke={color} fill="rgba(0, 229, 255, 0.2)" />
    <circle cx="24" cy="24" r="3" fill="#ffb300" />
  </svg>
);

export const CruiserIcon: React.FC<IconProps> = ({ size = 36, color = '#ffb300', className }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" stroke={color} strokeWidth="2" className={className}>
    <path d="M24 2 L42 12 L46 36 L36 46 L28 42 L24 46 L20 42 L12 46 L2 36 L6 12 Z" fill="rgba(255, 179, 0, 0.16)" />
    <polygon points="24 10 32 24 24 38 16 24" fill="rgba(255, 179, 0, 0.25)" />
    <circle cx="24" cy="24" r="4" fill="#00e5ff" />
  </svg>
);

// Modules
export const LaserIcon: React.FC<IconProps> = ({ size = 18, color = '#00e5ff', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" className={className}>
    <line x1="4" y1="12" x2="20" y2="12" strokeWidth="3" />
    <circle cx="20" cy="12" r="2" fill={color} />
  </svg>
);

export const AutocannonIcon: React.FC<IconProps> = ({ size = 18, color = '#ff9100', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" className={className}>
    <rect x="6" y="8" width="12" height="8" rx="1" fill="rgba(255, 145, 0, 0.3)" />
    <line x1="2" y1="12" x2="6" y2="12" strokeWidth="3" />
    <line x1="18" y1="12" x2="22" y2="12" strokeWidth="3" />
  </svg>
);

export const MissileIcon: React.FC<IconProps> = ({ size = 18, color = '#ff1744', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" className={className}>
    <path d="M12 2 L16 8 L14 18 L10 18 L8 8 Z" fill="rgba(255, 23, 68, 0.3)" />
    <line x1="12" y1="18" x2="12" y2="22" />
  </svg>
);

export const ShieldIcon: React.FC<IconProps> = ({ size = 18, color = '#00e5ff', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" className={className}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" fill="rgba(0, 229, 255, 0.2)" />
  </svg>
);

export const ArmorIcon: React.FC<IconProps> = ({ size = 18, color = '#90caf9', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" className={className}>
    <rect x="3" y="3" width="18" height="18" rx="2" fill="rgba(144, 202, 249, 0.2)" />
    <line x1="3" y1="9" x2="21" y2="9" />
    <line x1="3" y1="15" x2="21" y2="15" />
  </svg>
);

export const EngineIcon: React.FC<IconProps> = ({ size = 18, color = '#00e676', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" className={className}>
    <polygon points="12 2 19 21 12 17 5 21 12 2" fill="rgba(0, 230, 118, 0.2)" />
  </svg>
);

// Buildings
export const CommandCenterIcon: React.FC<IconProps> = ({ size = 28, color = '#ffb300', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" className={className}>
    <rect x="4" y="4" width="16" height="16" rx="2" fill="rgba(255, 179, 0, 0.15)" />
    <circle cx="12" cy="12" r="3" fill={color} />
    <line x1="12" y1="2" x2="12" y2="4" />
    <line x1="12" y1="20" x2="12" y2="22" />
    <line x1="2" y1="12" x2="4" y2="12" />
    <line x1="20" y1="12" x2="22" y2="12" />
  </svg>
);

export const MineIcon: React.FC<IconProps> = ({ size = 28, color = '#90caf9', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" className={className}>
    <path d="M14 2l6 6-4 4-6-6 4-4z" />
    <path d="M3 21l9-9" />
    <path d="M12.5 14.5l-2-2" />
  </svg>
);

export const RefineryIcon: React.FC<IconProps> = ({ size = 28, color = '#00e5ff', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" className={className}>
    <path d="M6 22V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16" fill="rgba(0, 229, 255, 0.12)" />
    <line x1="6" y1="12" x2="18" y2="12" />
    <line x1="6" y1="17" x2="18" y2="17" />
  </svg>
);

export const CommerceIcon: React.FC<IconProps> = ({ size = 28, color = '#ffb300', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" className={className}>
    <circle cx="12" cy="12" r="8" fill="rgba(255, 179, 0, 0.12)" />
    <line x1="12" y1="8" x2="12" y2="16" />
    <line x1="8" y1="12" x2="16" y2="12" />
  </svg>
);

export const VaultIcon: React.FC<IconProps> = ({ size = 28, color = '#78909c', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" className={className}>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <circle cx="12" cy="12" r="4" fill="rgba(120, 144, 156, 0.3)" />
  </svg>
);

export const ShipyardIcon: React.FC<IconProps> = ({ size = 28, color = '#00e5ff', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" className={className}>
    <polygon points="12 2 2 22 22 22 12 2" fill="rgba(0, 229, 255, 0.12)" />
    <line x1="7" y1="16" x2="17" y2="16" />
  </svg>
);

export const LabIcon: React.FC<IconProps> = ({ size = 28, color = '#7c4dff', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" className={className}>
    <path d="M10 2v7.31L4.69 18.25A2 2 0 0 0 6.36 21h11.28a2 2 0 0 0 1.67-2.75L14 9.31V2" fill="rgba(124, 77, 255, 0.15)" />
    <line x1="8.5" y1="2" x2="15.5" y2="2" />
  </svg>
);

// Navigation & Actions
export const CrosshairIcon: React.FC<IconProps> = ({ size = 20, color = '#ff1744', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" className={className}>
    <circle cx="12" cy="12" r="9" />
    <line x1="12" y1="3" x2="12" y2="7" />
    <line x1="12" y1="17" x2="12" y2="21" />
    <line x1="3" y1="12" x2="7" y2="12" />
    <line x1="17" y1="12" x2="21" y2="12" />
  </svg>
);

export const GalaxyIcon: React.FC<IconProps> = ({ size = 20, color = '#00e5ff', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <ellipse cx="12" cy="12" rx="10" ry="4" transform="rotate(-30 12 12)" strokeDasharray="3 2" />
    <ellipse cx="12" cy="12" rx="4" ry="10" transform="rotate(-30 12 12)" strokeDasharray="3 2" />
    <circle cx="12" cy="12" r="3" fill={color} />
  </svg>
);

export const PlanetIcon: React.FC<IconProps> = ({ size = 20, color = '#ffd700', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" className={className}>
    <circle cx="12" cy="12" r="6" fill="rgba(255, 215, 0, 0.2)" />
    <path d="M4 12c0 3.3 3.6 6 8 6s8-2.7 8-6-3.6-6-8-6-8 2.7-8 6z" transform="rotate(-20 12 12)" />
  </svg>
);

export const PirateIcon: React.FC<IconProps> = ({ size = 20, color = '#ff3366', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" className={className}>
    <circle cx="12" cy="11" r="5" fill="rgba(255, 51, 102, 0.25)" />
    <path d="M12 16v3M10 19h4" />
    <circle cx="10" cy="10" r="1" fill={color} />
    <circle cx="14" cy="10" r="1" fill={color} />
    <line x1="6" y1="18" x2="18" y2="6" strokeWidth="1.5" />
  </svg>
);

export const AsteroidIcon: React.FC<IconProps> = ({ size = 20, color = '#90caf9', className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" className={className}>
    <polygon points="12 3 18 6 21 13 16 20 8 21 3 14 5 7" fill="rgba(144, 202, 249, 0.2)" />
    <circle cx="10" cy="9" r="1.5" fill={color} />
    <circle cx="15" cy="14" r="1" fill={color} />
  </svg>
);
